<template>
    <span class="dz-badge">
        <slot></slot>
        <div v-if="txt === 'new'" class="badge-new" :style="txtStyle"></div>
        <span v-else-if="!!txt" class="badge" :style="txtStyle">{{ txt }}</span>
    </span>
</template>

<script>
export default {
    name: 'Badge',
    props: {
        txt: String,
        txtStyle: Object,
    },
};
</script>

<style lang="scss">
.dz-badge {
    position: relative;

    .badge {
        display: inline-block;
        background-color: red;
        box-shadow: 0px 0.5px 1px black;
        border-radius: 2px;
        color: #fff;
        line-height: 1;
        padding: 4px;
        border-bottom-left-radius: 0;
        font-size: 12px;
        position: absolute;
        // top: -103%;
        bottom: 90%;
        left: 103%;
        z-index: 1;
        white-space: nowrap;

        &:after {
            content: '';
            position: absolute;
            left: -3px;
            bottom: 0;
            width: 0;
            height: 0;
            border-bottom: 3px solid red;
            border-left: 3px solid transparent;
            box-shadow: 0px 0.5px 1px black;
        }
    }

    .badge-new {
        width: 33px;
        height: 15px;
        background-image: url('https://oss.fjdaze.com/tools/dzPopup/icon/newGif.gif');
        position: absolute;
        bottom: 90%;
        left: 103%;
        z-index: 1;
    }
}
</style>
